import { PropsWithChildren } from 'react'
import {
  ErrorDialog,
  UserDropdown,
  Sidebar,
  LanguageSelect,
  NoSubscriptionBanner,
} from 'shared/components'
import { useErrorDialog } from 'shared/hooks'
import { useShowBanner } from './Layout.utils'
import { Container, Content, TopBar, BannerContainer } from './Layout.style'

interface LayoutProps {}

const Layout = ({ children }: PropsWithChildren<LayoutProps>) => {
  const errorDialog = useErrorDialog()
  const showBanner = useShowBanner()

  return (
    <Container>
      <TopBar>
        <LanguageSelect />
        <UserDropdown />
      </TopBar>
      <Sidebar />
      {showBanner && (
        <BannerContainer>
          <NoSubscriptionBanner />
        </BannerContainer>
      )}
      <Content>{children}</Content>
      <ErrorDialog {...errorDialog} />
    </Container>
  )
}

export default Layout
